import React from 'react';
import LocalOfferRoundedIcon from '@material-ui/icons/LocalOfferRounded';
import strings from 'strings';
import FPIconButton from 'UI/components/atoms/FPIconButton';

export const CreateMultipleKeywordsButton = ({ onClick }) => {
  return (
    <FPIconButton
      onClick={onClick}
      showTooltipWhenDisabled
      icon={LocalOfferRoundedIcon}
      tooltipProps={{
        arrow: false,
        placement: 'bottom',
        title: strings.inventory.shared.listing.addKeywords
      }}
      iconProps={{
        onSetColor: ({ primary }) => primary.main
      }}
    />
  );
};
